import { useState } from 'react'

import { Cable, Copy, Check } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { ZoneStateStatus } from '@/core/api/entities/zone/state'

export const ActivateBadge = ({
	status,
	code,
}: {
	status: ZoneStateStatus
	code: string
}) => {
	const { t } = useTranslation('zones')
	const [copied, setCopied] = useState(false)
	const label =
		status === ZoneStateStatus.NOT_INSTALLED
			? t('card.notInstalled')
			: t('card.notReactivated')

	const handleCopy = async (e: React.MouseEvent) => {
		e.stopPropagation()
		try {
			await navigator.clipboard.writeText(code)
			setCopied(true)
			setTimeout(() => setCopied(false), 2000)
		} catch (err) {
			console.error('Failed to copy:', err)
		}
	}

	return (
		<div className="inline-flex items-center rounded-md border border-border overflow-hidden text-sm font-medium h-6">
			<div className="flex items-center gap-1.5 px-2 py-0.5 bg-shade text-muted-foreground">
				<Cable className="h-3.5 w-3.5" />
				<span>{label}</span>
			</div>
			<button
				onClick={handleCopy}
				className="hidden md:flex items-center gap-1 px-2 py-1 bg-muted hover:bg-muted/80 transition-colors cursor-pointer"
				title={copied ? t('card.copied') : t('card.copyCode')}
				id="activate-badge-copy-button"
				data-testid="activate-badge-copy-button"
			>
				<span className="text-foreground font-mono text-xs">{code}</span>
				{copied ? (
					<Check className="h-3.5 w-3.5 text-zone-online" />
				) : (
					<Copy className="h-3.5 w-3.5 text-muted-foreground" />
				)}
			</button>
		</div>
	)
}
